export const acceptedImages = {
    'image/jpg': ['.jpg'],
    'image/jpeg': ['.jpeg'],
    'image/png': ['.png'],
    'image/gif': ['.gif'],
};
